<script setup lang="ts">
import { onMounted, ref } from 'vue';
import { getFileList, getYarnData, type QingflowFile, type YarnData } from '@/api/exhibition';
import { Field, Image } from 'vant';
import { getFileType } from '@repo/utils';
import { Carousels } from '@/components';

const props = defineProps<{
  enterpriseId: string,
  dataId: string,
}>();

const yarnData = ref<YarnData>();

type FileItem = QingflowFile & { type: 'video' | 'image' | 'unknown' }
const coverImageList = ref<FileItem[]>([]);
const imageList = ref<FileItem[]>([]);
const videoList = ref<FileItem[]>([]);

onMounted(async () => {
  try {
    yarnData.value = await getYarnData({
      enterpriseId: props.enterpriseId,
      dataId: props.dataId
    });

    coverImageList.value = [];
    if (yarnData.value.coverImage) {
      const coverImages = await getFileList({ ...yarnData.value.coverImage, enterpriseId: props.enterpriseId });
      coverImageList.value = [...coverImages.map(item => ({ ...item, type: getFileType(item.name) }))];
    }

    if (yarnData.value.video) {
      const videos = await getFileList({ ...yarnData.value.video, enterpriseId: props.enterpriseId });
      videoList.value = [...videos.map(item => ({ ...item, type: getFileType(item.name) }))];
    }

    if (yarnData.value.image) {
      const images = await getFileList({ ...yarnData.value.image, enterpriseId: props.enterpriseId });
      imageList.value = [...images.map(item => ({ ...item, type: getFileType(item.name) }))];
    }
  } catch (e) {
    console.error(e);
  }
});
const properties = ['名称', '品牌', '纱支', '成份', '单价(元/kg)', '库存(kg)', '联系人', '电话']
</script>

<template>
  <div>
    <div>
      <Carousels :file-list="coverImageList" />
      <template v-for="file of imageList" :key="file.url">
        <Image v-if="file.type === 'image'" width="100%" :alt="file.name" :src="file.url" />
        <video v-else-if="file.type === 'video'" style="width: 100%;" preload="metadata" controls :autoplay="false">
          <source :src="file.url" type="video/mp4" />
        </video>
      </template>
    </div>
    <template v-for="file of videoList" :key="file.url">
      <Image v-if="file.type === 'image'" width="100%" :alt="file.name" :src="file.url" />
      <video v-else-if="file.type === 'video'" style="width: 100%;" preload="metadata" controls :autoplay="false">
        <source :src="file.url" type="video/mp4" />
      </video>
    </template>
    <Field v-for="prop in properties" :key="prop" :label="prop" :model-value="yarnData?.property?.[prop] ?? ''"
           readonly />
  </div>
</template>

<style scoped></style>